import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';

// Modules
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MaterialModule } from 'src/app/platform/material.module';
import { UiModule } from 'src/app/platform/ui.module';
import { PlatformModule } from 'src/app/platform/platform.module';
import { UserModule } from 'src/app/modules/account/user.module';
import { PaginatorIntlTranslate } from 'src/app/platform/utils/translate-paginator-intl';

// Directives
import { PhoneMaskDirective } from 'src/app/platform/utils/phone.directive';

// Componentes
import { AppComponent } from 'src/app/app.component';
import { DgoComponent } from 'src/app/modules/public/views/dgo/dgo.component';
import { LoginComponent } from 'src/app/platform/views/login/login.component';

import { SummaryComponent } from 'src/app/modules/summary/views/summary/summary.component';

import { AccountComponent } from 'src/app/modules/account/views/account/account.component';
import { AccountDeleteComponent } from 'src/app/modules/account/views/account-delete/account-delete.component';
import { AccountPasswordChangeComponent } from 'src/app/modules/account/views/account-password-change/account-password-change.component';

import { PaymentsComponent } from 'src/app/modules/payments/views/payments/payments.component';
import { PaymentsReceiptComponent } from 'src/app/modules/payments/views/payments-receipt/payments-receipt.component';
import { PaymentsReportComponent } from 'src/app/modules/payments/views/payments-report/payments-report.component';
import { PaymentsStatusComponent } from './modules/payments/views/payments-status/payments-status.component';

import { ProceduresComponent } from 'src/app/modules/procedures/views/procedures/procedures.component';
import { ProceduresButtonsComponent } from 'src/app/modules/procedures/views/procedures-buttons/procedures-buttons.component';
import { ProceduresListComponent } from 'src/app/modules/procedures/views/procedures-list/procedures-list.component';
import { ProceduresDebitComponent } from 'src/app/modules/procedures/views/procedures-debit/procedures-debit.component';
import { ProceduresNewComponent } from 'src/app/modules/procedures/views/procedures-new/procedures-new.component';
import { ProceduresDetailComponent } from 'src/app/modules/procedures/views/procedures-detail/procedures-detail.component';

import { ProductsComponent } from 'src/app/modules/products/views/products/products.component';
import { ProductsAddComponent } from 'src/app/modules/products/views/products-add/products-add.component';
import { ProductsDeleteComponent } from 'src/app/modules/products/views/products-delete/products-delete.component';
import { ProductsChangeComponent } from 'src/app/modules/products/views/products-change/products-change.component';
import { PayModalComponent } from 'src/app/modules/payments/components/pay-modal/pay-modal.component';

import { InvoicesComponent } from 'src/app/modules/invoices/views/invoices/invoices.component';
import { InvoicesEmailSendComponent } from 'src/app/modules/invoices/views/invoices-email-send/invoices-email-send.component';
import { InvoicesCallsListComponent } from 'src/app/modules/invoices/views/invoices-calls-list/invoices-calls-list.component';


@NgModule({
  declarations: [
    AppComponent,
    DgoComponent,
    LoginComponent,
    SummaryComponent,
    AccountComponent,
    AccountDeleteComponent,
    AccountPasswordChangeComponent,
    PaymentsComponent,
    PaymentsReceiptComponent,
    PaymentsReportComponent,
    PaymentsStatusComponent,
    PayModalComponent,
    ProceduresComponent,
    ProceduresButtonsComponent,
    ProceduresListComponent,
    ProceduresDebitComponent,
    ProceduresNewComponent,
    ProceduresDetailComponent,
    ProductsComponent,
    ProductsAddComponent,
    ProductsDeleteComponent,
    ProductsChangeComponent,
    InvoicesComponent,
    InvoicesEmailSendComponent,
    InvoicesCallsListComponent,

    PhoneMaskDirective
  ],
  imports: [
    UiModule,
    UserModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    PlatformModule,
    MaterialModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  exports: [
    MaterialModule,

    PhoneMaskDirective
  ],
  providers: [
    DatePipe,
    {provide: MatPaginatorIntl, useValue: PaginatorIntlTranslate()},
    {provide: MAT_DATE_LOCALE, useValue: 'es-AR'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
